// src/components/Checkout/CartSummary.tsx

import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Checkout.module.scss";
import { getSiteConfig } from "@/config/siteConfigs";

const siteConfig = getSiteConfig();
type OrderType = "exchpart" | "sellpart";

const CRM_TOKEN = "DH345DFGDGb32FDsf03876SDFSdf13";

interface CartSummaryProps {
  cart: Array<{
    goid: string;
    quantity: number;
    table: string;
    typeorder: OrderType;
  }>;
}

export const CartSummary: React.FC<CartSummaryProps> = ({ cart }) => {
  const { t } = useTranslation("common");
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAllProducts = async () => {
      setLoading(true);
      let total = 0;
      let itemsCount = 0;

      const promises = cart.map(async (item) => {
        try {
          const response = await fetch(
            `https://crm.hixa.eu/external/goodsapi/?legid=1&language=${siteConfig.language}&type=good&goid=${item.goid}&table=${item.table}`,
            {
              method: "GET",
              headers: {
                Authorization: `Bearer ${CRM_TOKEN}`,
                Accept: "application/json",
                "User-Agent": "Mozilla/5.0 (compatible; SitemapGenerator/1.0)",
              },
            }
          );

          if (response.ok) {
            const data = await response.json();
            if (data.data && data.data.length > 0) {
              const productData = data.data[0];
              const price =
                item.typeorder === "sellpart"
                  ? parseFloat(productData.pricevat)
                  : parseFloat(productData.priceexchvat);

              return {
                price: price || 0,
                quantity: item.quantity,
              };
            }
          }
        } catch (error) {
          console.error(`Error fetching product ${item.goid}:`, error);
        }
        return { price: 0, quantity: 0 };
      });

      const results = await Promise.all(promises);

      results.forEach((result) => {
        total += result.price * result.quantity;
        itemsCount += result.quantity;
      });

      setTotalAmount(total);
      setTotalItems(itemsCount);
      setLoading(false);
    };

    if (cart.length > 0) {
      fetchAllProducts();
    } else {
      setTotalAmount(0);
      setTotalItems(0);
      setLoading(false);
    }
  }, [cart]);

  if (loading && cart.length > 0) {
    return (
      <div className={styles.summary}>
        <p>{t("cart.loadingSummary")}</p>
      </div>
    );
  }

  return (
    <>
      <li className={styles.summary}>
        <p>
          {t("cart.subtotal")} · {totalItems} {t("cart.items")} ·
        </p>
        <p>{totalAmount.toFixed(2)}€</p>
      </li>
      <li className={styles.summary}>
        <p className={styles.total}>{t("cart.total")}</p>
        <div className={styles.totalPriceBlock}>
          <p className={styles.fs12}>EUR </p>
          <p className={styles.totalPrice}>{totalAmount.toFixed(2)}€</p>
        </div>
      </li>
    </>
  );
};
